import { useTypedSelector } from '@/store/reducers/use-typed-selector';
import { selectEditorNavV3 } from '@/store/selectors/feature-flags';
import { CSSProperties, memo, useMemo } from 'react';

type TFullPageProjectThemeGradientProps = {
	top?: CSSProperties['top'];
	left?: CSSProperties['left'];
	position?: CSSProperties['position'];
	transform?: CSSProperties['transform'];
	height?: CSSProperties['height'];
	width?: CSSProperties['width'];
	borderRadius?: CSSProperties['borderRadius'];
	filter?: CSSProperties['filter'];
	zIndex?: CSSProperties['zIndex'];
	'data-component'?: string;
};

const FullPageProjectThemeGradient = memo((props?: TFullPageProjectThemeGradientProps) => {
	const {
		top = '-55vh',
		left = '50%',
		position = 'fixed',
		transform = 'translateX(-50%)',
		height = '816px',
		width = '816px',
		borderRadius = '50%',
		filter = 'blur(200px)',
		'data-component': dataComponent,
		zIndex = -1,
	} = props || {};

	const isV3 = useTypedSelector(selectEditorNavV3);
	const workingEventUuid = useTypedSelector(state => state.CreateEventReducer.workingEvent?.uuid);

	const styles: CSSProperties = useMemo(() => {
		return {
			position,
			transform,
			borderRadius,
			opacity: '0.32',
			background: 'var(--accentColor)',
			filter,
			top,
			left,
			height,
			width,
			zIndex,
			pointerEvents: 'none',
		};
	}, [borderRadius, filter, height, left, position, top, transform, width, zIndex]);

	/* wait for the project uuid to be available or it will briefly render the wrong color on page refresh */
	if (!isV3 || !workingEventUuid) return null;
	return <div data-component={dataComponent || 'FullPageProjectThemeGradient'} style={styles} />;
});

FullPageProjectThemeGradient.displayName = 'FullPageProjectThemeGradient';

export default FullPageProjectThemeGradient;
